<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte/internal';

	const dispatch = createEventDispatcher();

	export let current = 1;
	export let num_pages = 1;
	export let per_page;

	let arr_pages = [];

	let gapClass = '';

	function buildArr(c, n) {
		if (n <= 7) {
			return [...Array(n)].map((_, i) => i + 1);
		} else {
			if (c < 3 || c > n - 2) {
				return [1, 2, 3, '...', n - 2, n - 1, n];
			} else {
				return [1, '...', c - 1, c, c + 1, '...', n];
			}
		}
	}

	function setArrPages() {
		arr_pages = buildArr(current, num_pages);
		const maxDigits = Math.max(...arr_pages.filter(page => typeof page === 'number').map(page => page.toString().length));
        gapClass = maxDigits === 3 ? 'gap-x-2' : maxDigits >= 4 ? 'gap-x-3' : '';
	}

	$: if (current) {
		setArrPages();
	}

	$: if (per_page) {
		setArrPages();
	}

	$: if (num_pages) {
		num_pages = num_pages || 1;
		current = current || 1;
	}

	function setCurrent(i, j) {
		if (isNaN(i) && isNaN(j)) return;
		current = i;
		per_page = j;
		dispatch('navigate', { current: current, per_page: per_page });
	}
</script>

<div class="flex float-right mt-4 text-base text-gray-700">
	<div class="flex items-center">
		{$_('global.elements_per_page')}:
		<select
			class="px-2 ml-2 border rounded"
			style="font-family: initial;"
			bind:value="{per_page}"
			on:change="{setCurrent(1, parseInt(per_page))}"
		>
			<option value="{5}">5</option>
			<option value="{10}">10</option>
			<option value="{25}">25</option>
			<option value="{50}">50</option>
		</select>
	</div>
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div
		role="button"
		tabindex="0"
		class="mr-1 flex h-7.5 w-7.5 items-center justify-center {current > 1 ? 'cursor-pointer' : 'text-gray-400'}"
		on:click="{() => current > 1 && setCurrent(current - 1, per_page)}"
	>
		<span class="material-icons-outlined">chevron_left</span>
	</div>
	<div class="flex h-7.5 font-medium {gapClass}">
		{#each arr_pages as i}
			<!-- svelte-ignore a11y-interactive-supports-focus -->
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<div
			role="button"
			tabindex="0"
				class="hidden w-7.5 cursor-pointer select-none items-center justify-center
        leading-5 transition duration-150 ease-in sm:flex {i == current ? `border-t-2 border-mobilityPlatform-green ` : 'border-t-2 border-white'}
        "
				on:click="{() => setCurrent(i, per_page)}"
			>
				{i}
			</div>
		{/each}
		<div
			class="flex h-7.5 w-7.5 cursor-pointer select-none items-center justify-center border-t-2 border-mobilityPlatform-green leading-5 transition duration-150 ease-in sm:hidden"
		>
			{current}
		</div>
	</div>
	<div
		role="button"
		tabindex="0"
		class="ml-1 flex h-7.5 w-7.5 items-center justify-center {current < num_pages ? 'cursor-pointer' : 'text-gray-400'}"
		on:keydown="{() => current < num_pages && setCurrent(current + 1, per_page)}"
		on:click="{() => current < num_pages && setCurrent(current + 1, per_page)}"
	>
		<span class="material-icons-outlined">chevron_right</span>
	</div>
</div>
